export const BsToast = (props) => {
    return (
        <div aria-live="polite" aria-atomic="true" className="bg-body-secondary  bd-example-toasts rounded-3">
        <div  className="toast-container p-3 top-0 start-50 translate-middle-x" >
            <div className="toast" id="toastID">
            <div className="toast-header">
                <img src="..." className="rounded me-2" alt="..."/>
                <strong className="me-auto">Bootstrap</strong>
                <small>11 mins ago</small>
            </div>
            <div className="toast-body">
                Hello, world! This is a toast message.
            </div>
            </div>
        </div>
        </div>
    )
}